<template>
  <div>
    <vs-prompt
      id="document-delete-dialog"
      @accept="deleteDocument"
      @cancel="cancel"
      @close="close"
      :color="AISEA_COLOR.RED"
      :active.sync="showDialog"
      :title="title"
      :accept-text="acceptText"
      :cancel-text="cancelText"
    >
      <div>
        <div>以下の書類を削除しますか？削除後は復旧できません。</div>
        <VuePerfectScrollbar
          class="scroll-area mt-2 mb-4"
          :settings="scrollbarSettings"
        >
          <div
            v-for="(item, index) in selectedDocuments"
            :key="index"
            class="px-4 py-1 flex items-center"
          >
            <feather-icon
              svgClasses="h-4 w-4"
              :icon="sourceDocumentIcon(item)"
            ></feather-icon>
            <span class="ml-2 text-sm">
              {{ sourceDocumentName(item.path) }}
            </span>
          </div>
        </VuePerfectScrollbar>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { ColorMixin, DocumentMixin } from "@/mixins";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

const {
  mapActions: mapActionsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");

export default {
  components: { VuePerfectScrollbar },
  mixins: [ColorMixin, DocumentMixin],
  data () {
    return {
      error: { message: null },
      showDialog: false,
      title: "削除",
      acceptText: "削除",
      cancelText: "キャンセル",
    };
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "selectedDocuments",
      "documentRootPath"
    ]),
  },
  methods: {
    ...mapActionsOfenterpriseDocumentManager([
      "deleteFile",
      "deleteFolder"
    ]),
    show () {
      this.showDialog = true;
    },
    sourceDocumentIcon (document) {
      if (!document.type) return "FolderIcon"
      return this.getDocumentMimeIcon(document.type)
    },
    sourceDocumentName (name) {
      return name.replace(this.documentRootPath, "")
    },
    async deleteDocument () {
      try {
        this.$vs.loading();
        const promiseAll = this.selectedDocuments.map(item => {
          if (item.size) {
            return this.deleteFile(item.path)
          } else {
            return this.deleteFolder(item.path)
          }
        });
        await Promise.all(promiseAll);
        this.$vs.loading.close();
        this.$vs.notify({
          title:
            "書類を削除しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.$emit("onUpdate");
        this.close();
      } catch (error) {
        console.error(error);
        this.$vs.loading.close();
        this.$vs.notify({
          title: `書類の削除に失敗しました`,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
      this.close();
    },
    close () {
      this.cleanUp();
    },
    cancel () {
      this.cleanUp();
    },
    cleanUp () {
      this.showDialog = false;
    }
  }
};
</script>

<style lang="scss">
#document-delete-dialog {
  .scroll-area {
    max-height: 240px;
  }
}
</style>
